var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.126 14H.22V4.656h2.906V14zM1.688 3.375c-.459 0-.855-.167-1.188-.5-.333-.333-.5-.73-.5-1.188C0 1.23.167.834.5.5.833.167 1.23 0 1.688 0c.458 0 .854.167 1.187.5.333.333.5.73.5 1.188 0 .458-.167.854-.5 1.187-.333.333-.73.5-1.188.5zM14 14h-2.906V9.438c0-.75-.063-1.292-.188-1.625-.229-.563-.677-.844-1.344-.844-.666 0-1.135.25-1.406.75-.208.375-.312.927-.312 1.656V14H4.97V4.656h2.78v1.282h.032c.208-.417.542-.76 1-1.032.5-.333 1.083-.5 1.75-.5 1.354 0 2.302.427 2.844 1.282.417.687.625 1.75.625 3.187V14z",
    fill: "#12171A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.a53bf88e.svg";
export { ForwardRef as ReactComponent };